export default class Loader {
    static show(title, text) {
        Swal.fire({
            title: title,
            text: text,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
        });
        Swal.showLoading();
    }

    static close() {
        Swal.close();
    }
}